import Vue from 'vue';
import Vuex from 'vuex';

import { RootState } from '@/store/types';

import filterStore from './filter';
import comparatorStore from './comparator';
import scholenStore from './scholen';
import mboStore from './mbo/store';

Vue.use(Vuex);

export default new Vuex.Store<RootState>({
  state: {
    version: 0.9,
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    filter: filterStore,
    comparator: comparatorStore,
    scholen: scholenStore,
    mbo: mboStore,
  },
});
